<template>
  <ToastAlert v-if="show" :message="message" :type="type" :duration="duration" @close="closeToast" />
</template>

<script setup>
const { show, message, type, duration, closeToast } = useToast();
</script>
